import { useTheme } from '@mui/material/styles';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import { ActualIconProps } from 'mobx/commonTypes';
import React, { useContext } from 'react';
import { UiContext } from 'uiContext';
import cx from 'classnames';

export default function IconCODD({
  onClick,
  extColor,
  isAutoscallable = true,
  sizeKey = '14x17',
  style,
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.primary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconCODD', onClick ? '' : 'icon_disabled')}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={Math.round(w)}
      height={Math.round(h)}
      viewBox="0 0 15 17"
      fill={fill}
    >
      <path d="M6.1954 15.928L7 16.7224L11.9483 11.8368C13.1954 10.5657 14 8.85771 14 6.95111C14 3.09821 10.8621 0 7 0C3.13793 0 0 3.09821 0 6.91139C0 8.81798 0.804599 10.5657 2.05173 11.797C2.17241 11.9162 2.2931 11.9559 2.45402 11.9559C2.77586 11.9559 3.01724 11.7176 3.01724 11.3998C3.01724 11.2409 2.93678 11.0821 2.85632 11.0026C1.81035 9.96988 1.12644 8.50022 1.12644 6.91139C1.12644 3.69402 3.78161 1.11218 7 1.11218C10.2586 1.11218 12.8736 3.73374 12.8736 6.91139C12.8736 8.50022 12.2299 9.96988 11.1437 11.0026L6.1954 15.928Z" />
      <path d="M4.14355 8.41984H3.21826L6.51711 5.24219H7.4424L4.14355 8.41984Z" />
      <path d="M5.91357 8.41984H4.98828L8.28713 5.24219H9.21242L5.91357 8.41984Z" />
      <path d="M7.76415 8.41984H6.83887L10.1377 5.24219H11.063L7.76415 8.41984Z" />
    </svg>
  );
}
